
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/video",
      function () {
        return require("private-next-pages/dashboard/video/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/video"])
      });
    }
  